import { VetGroup } from './tierarzt-gruppe';

export class Tierarzt {
    tierarzt_id: number;
    tierarztgruppen: VetGroup[] = [];
    benutzer_id: number;
    vorname: string;
    nachname: string;
    lagerplatz_id: number;
    lagerplatz: string;
    tierarztnummer: number;
    qs_alias: string;
    abgabebeleg_nr: number;
    editiert: Date;
    titel: string;
    unterschrift: string;
    tierarztgruppe_id: number;
    tierarztgruppe: string;
    tierarztgruppe_farbe: string;
    tierarztgruppe_hintergrundfarbe: string;
    email: string;
    mobil: string;
    telefon: string;
    plz: string;
    ort: string;
    strasse: string;
}

export class TierarztCreate extends Tierarzt {
    sende_email: number; // nur fürs anlegen
    passwort: string; // nur fürs anlegen
    kennzeichen: string; // nur fürs anlegen
}

export class VetGroupVet {
    tt_id: number;
    tierarztgruppe_id: number;
    tierarztgruppe: string;
    tierarzt_id: number;
    vorname: string;
    nachname: string;
}
